/* eslint-disable jsx-a11y/heading-has-content */
import { Button, ButtonGroup, Card, Form } from "@themesberg/react-bootstrap";
import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import SearchInput from "../../../components/SearchInput";
import CustomTable from "../../../components/CustomTable";
import { useSelector } from "react-redux";
import { fetchApi, postApi } from "../../../redux/api";
import { useNavigate } from "react-router-dom";
import { Routes } from "../../../routes";
import { Table } from "reactstrap";
import { formatNumber } from "../../../redux/utils";

const UploadPV = () => {
  const [filterText, setFilterText] = useState("");
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");
  const [loading, setLoading] = useState(false);
  const [pvList, setPvList] = useState([]);
  const mda = useSelector((state) => state.auth.user) || {};
  const navigate = useNavigate();

  // const getPvByMdaName = React.useCallback(() => {
  //   setLoading(true);
  //   postApi("get_new_pv_by_mda", {
  //     query_type: "view_upload_pv",
  //     mda_name: mda.mda_name,
  //     mda_code: mda.mda_code,
  //   })
  //     .then((data) => {
  //       setLoading(false);
  //       setPvList(data.result);
  //     })
  //     .catch((error) => {
  //       setLoading(false);
  //     });
  // }, [mda.mda_name, mda.mda_code]);

  useEffect(() => {
    if (mda?.mda_name && mda?.mda_code) {
      setLoading(true);
      fetchApi(
        `get_new_pv_by_mda?query_type=view_upload_pv&mda_name=${mda.mda_name}&mda_code=${mda.mda_code}`
      )
        .then((data) => {
          setPvList(data.result || []);
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [mda]);

  return (
    <div>
      <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
        <div className="d-block mb-4 mb-md-0">
          <h4>Upload Signed PV</h4>
        </div>
        <div className="btn-toolbar mb-2 mb-md-0">
          <ButtonGroup>
            <Button variant="outline-primary" size="sm">
              Share
            </Button>
            <Button variant="outline-primary" size="sm">
              Export
            </Button>
          </ButtonGroup>
        </div>
      </div>
      <Row>
        <Col
          md={6}
          style={{
            marginTop: 28,
          }}
        >
          <SearchInput
            placeholder="Search For Review Releases"
            value={filterText}
            onChange={(e) => setFilterText(e.target.value)}
          />
        </Col>
        <Col md={6}>
          <Row
            style={{
              marginBottom: 10,
            }}
          >
            <Col md={6}>
              <Form.Group id="date_from">
                <Form.Label>Date From</Form.Label>
                <Form.Control
                  type="date"
                  value={dateFrom}
                  onChange={(e) => setDateFrom(e.target.value)}
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group id="date_to">
                <Form.Label>Date to</Form.Label>
                <Form.Control
                  type="date"
                  value={dateTo}
                  onChange={(e) => setDateTo(e.target.value)}
                />
              </Form.Group>
            </Col>
          </Row>
        </Col>
      </Row>
      <Card border="light" className="table-wrapper table-responsive shadow-sm">
        <Card.Body
          className="p-0"
          style={{ height: "80vh", overflow: "scroll" }}
        >
          {loading ? (
            <div className="d-flex justify-content-center">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          ) : (
            <Table hover style={{ width: "100%" }} bordered>
              <thead className="table-header">
                <tr className="file-list-item">
                  <th style={{ backgroundColor: "#099019", color: "white" }}>
                    Action
                  </th>
                  <th style={{ backgroundColor: "#099019", color: "white" }}>
                    MDA Name
                  </th>
                  <th style={{ backgroundColor: "#099019", color: "white" }}>
                    MDA Code
                  </th>
                  <th style={{ backgroundColor: "#099019", color: "white" }}>
                    Economic Code
                  </th>
                  <th style={{ backgroundColor: "#099019", color: "white" }}>
                    Economic Description
                  </th>
                  <th style={{ backgroundColor: "#099019", color: "white" }}>
                    Fund Code
                  </th>
                  <th style={{ backgroundColor: "#099019", color: "white" }}>
                    Fund Description
                  </th>
                  <th style={{ backgroundColor: "#099019", color: "white" }}>
                    Amount Payable
                  </th>
                </tr>
              </thead>
              <tbody>
                {pvList?.map((item, index) => (
                  <tr key={index}>
                    <td>
                      <Button
                        onClick={() => {
                          navigate(
                            `${Routes.pv.pvCheckedIndex}/${item.pv_code}`
                          );
                        }}
                      >
                        Upload Signed PV
                      </Button>
                    </td>
                    <td style={{ textAlign: "center", color: "#000" }}>
                      {item.mda_name}
                    </td>
                    <td style={{ textAlign: "center", color: "#000" }}>
                      {item.mda_code}
                    </td>
                    <td style={{ textAlign: "center", color: "#000" }}>
                      {item.economic_code}
                    </td>
                    <td style={{ textAlign: "center", color: "#000" }}>
                      {item.description_code}
                    </td>
                    <td style={{ textAlign: "center", color: "#000" }}>
                      {item.fund_code}
                    </td>
                    <td style={{ textAlign: "center", color: "#000" }}>
                      {item.fund_description}
                    </td>
                    <td style={{ textAlign: "center", color: "#000" }}>
                      {formatNumber(item.amount)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          )}
        </Card.Body>
      </Card>
    </div>
  );
};

export default UploadPV;
